import { useEffect } from 'react'
import { t } from 'i18next'

import { isForRuMarket } from 'common/constants'
import { getHrmName } from 'common/helpers'

export const useDocumentHead = () => {
  useEffect(() => {
    document.title = `${t('App.vacancyPortal')} | ${getHrmName()}`

    const href = isForRuMarket ? '/favicon-ru.ico' : '/favicon-global.ico'
    const link: HTMLLinkElement = document.querySelector('link[rel*=\'icon\']') || document.createElement('link')
    link.type = 'image/png'
    link.rel = 'icon'
    link.href = href
    document.head.appendChild(link)
  }, [])
}
